<template>
  <BaseTableItemAction
    v-can:[editPermission]
    v-on="$listeners"
    v-bind="$attrs"
    icon="mdi-pencil"
    actionName="تعديل"
    @click="openEditDialog()"
  >
    <slot></slot>
    <EditJobFieldDialog
      :item="item"
      :showCondition="showEditDialog"
      @closed="closeEditDialog"
    />
  </BaseTableItemAction>
</template>

<script>
import EditJobFieldDialog from "../dialogs/EditJobFieldDialog.vue";
import { WRITE_JOBS_PERMISSION } from "@/core/statics/Permissions";

export default {
  components: { EditJobFieldDialog },
  props: {
    item: Object,
  },
  data() {
    return {
      editPermission: WRITE_JOBS_PERMISSION,
      showEditDialog: false,
    };
  },
  methods: {
    openEditDialog() {
      this.showEditDialog = true;
    },
    closeEditDialog() {
      this.showEditDialog = false;
    },
  },
};
</script>

<style></style>
